import { useState } from "react";
import {
  Box,
  Drawer,
  List,
  ListItem,
  ListItemButton,
  ListItemText,
  CssBaseline,
} from "@mui/material";
import Update360Page from "./Update360Page";
import UploadToCirclePage from "./UploadToCirclePage";
import { Outlet, useNavigate } from "react-router-dom";
import { useAuth } from "../../common/contexts/AuthProvider";
import { UserPermissionGroup } from "../../common/models/schema/UserPermissionGroup";

const drawerWidth = 240;

enum MenuItem {
  Update360 = "360Update",
  ProfileVersion = "ProfileVersions",
  UploadToCircle = "UploadToCircle",
  UsersManager = "UsersManager",
  TagsManager = "TagsManager",
  AdminInvitations = "AdminInvitations",
}

const menuItems = [
  { id: MenuItem.Update360, label: "Update 360" },
  { id: MenuItem.ProfileVersion, label: "Profile Version" },
  { id: MenuItem.UploadToCircle, label: "Upload To Circle" },
];

const adminMenuItems = [
  { id: MenuItem.UsersManager, label: "Users Manager" },
  { id: MenuItem.TagsManager, label: "Tags Manager" },
  { id: MenuItem.AdminInvitations, label: "Admin Invitations" },
];

function DashboardPage() {
  const [selectedItem, setSelectedItem] = useState(MenuItem.Update360);
  const { handleSignOut, userPermissions } = useAuth();
  const navigate = useNavigate();

  const handleMenuItemClick = (item: MenuItem) => {
    setSelectedItem(item);
    navigate(`/dashboard/${item}`);
  };

  return (
    <Box sx={{ display: "flex" }}>
      <CssBaseline />

      <Drawer
        sx={{
          width: drawerWidth,
          flexShrink: 0,
          "& .MuiDrawer-paper": { width: drawerWidth, boxSizing: "border-box" },
        }}
        variant="permanent"
      >
        <List>
          {menuItems.map((item) => (
            <ListItem key={item.id} disablePadding>
              <ListItemButton
                selected={selectedItem === item.id}
                onClick={() => handleMenuItemClick(item.id)}
              >
                <ListItemText primary={item.label} />
              </ListItemButton>
            </ListItem>
          ))}
          {userPermissions === UserPermissionGroup.Admin && (
            <List>
              {adminMenuItems.map((item) => (
                <ListItem key={item.id} disablePadding>
                  <ListItemButton
                    selected={selectedItem === item.id}
                    onClick={() => handleMenuItemClick(item.id)}
                  >
                    <ListItemText primary={item.label} />
                  </ListItemButton>
                </ListItem>
              ))}
            </List>
          )}
        </List>

        <Box sx={{ flexGrow: 1 }} />
        <ListItem
          disablePadding
          sx={{ position: "absolute", bottom: 0, width: "100%" }}
        >
          <ListItemButton onClick={handleSignOut}>
            <ListItemText primary="Sign Out" />
          </ListItemButton>
        </ListItem>
      </Drawer>

      <Box component="main" sx={{ flexGrow: 1 }}>
        {/* {renderContent()} */}
        <Outlet />
      </Box>
    </Box>
  );
}

export default DashboardPage;
